/**
 * EmptyState — supports both children-based and variant-based rendering.
 *
 * Relocated from legacy.tsx by T312 (FR-015).
 * Uses CSS custom-property references for spacing and layout.
 */
import React from "react";
import type { ReactNode, CSSProperties } from "react";

export interface EmptyStateProps {
  children?: ReactNode;
  variant?: "forbidden" | "empty";
  ctaHref?: string;
}

const containerStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "var(--space-md, 12px)",
  padding: "var(--space-2xl, 32px) var(--space-lg, 16px)",
  textAlign: "center",
  opacity: 0.7,
};

export function EmptyState({ children, variant, ctaHref }: EmptyStateProps) {
  if (variant === "forbidden") {
    return (
      <div role="status" data-testid="empty-state" style={containerStyle}>
        <p>You do not have access to this page.</p>
        {ctaHref && <a href={ctaHref}>Go back</a>}
      </div>
    );
  }

  return (
    <div role="status" data-testid="empty-state" style={containerStyle}>
      {children}
    </div>
  );
}
